const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "API de Mensajes",
    summary:
      "Integra sistemas externos (CRM, ERP, tiendas en línea o pasarelas de pago) para enviar mensajes de texto y multimedia por WhatsApp mediante llamadas HTTP REST seguras con token de autorización.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Endpoints de Envío",
      description:
        "Especificación de URLs, cabeceras de autorización y parámetros JSON para envíos.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envío de Mensajes de Texto",
          definition:
            "Endpoint POST para enviar mensajes individuales de texto. Requiere el Token de API de la conexión, el cual se obtiene en el menú Conexiones > Editar canal de WhatsApp > sección Seguridad > Copiar Token.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envío de Archivos y Multimedia",
          definition:
            "Permite adjuntar archivos PDF, imágenes, videos o notas de voz especificando la URL pública o archivo multipart. Al igual que los envíos de texto, se autentica obligatoriamente con el Token de API obtenido en el menú Conexiones.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Tokens y Seguridad",
      description:
        "Generación y control de tokens Bearer de autenticación por empresa o conexión.",
      items: [
        {
          id: "bearer_token",
          title: "Token de Autorización (¿Dónde se obtiene?)",
          definition:
            "¿De dónde se obtiene el token? Ve al menú lateral Conexiones (/connections), pulsa el botón Editar (lápiz) de la conexión de WhatsApp que enviará los mensajes, entra a la pestaña de Seguridad y haz clic en 'Copiar Token' en la tarjeta de Token API. Úsalo en la cabecera HTTP 'Authorization: Bearer <token>'.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Messages API",
    summary:
      "Integrate external software (CRM, ERP, e-commerce, or payment gateways) to send text and media WhatsApp messages via secure REST HTTP endpoints authenticated with bearer tokens.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Dispatch Endpoints",
      description:
        "URLs, headers, and JSON body parameters for automated outbound messages.",
      items: [
        {
          id: "mensajes_texto",
          title: "Text Message API",
          definition:
            "POST endpoint to send single text messages. Requires the connection's API Token, which can be retrieved from Connections menu > Edit WhatsApp channel > Security section > Copy Token.",
        },
        {
          id: "mensajes_multimedia",
          title: "Media & Attachments API",
          definition:
            "Allows attaching PDF files, images, videos, or voice notes via public URL or multipart payload. Authenticated using the connection's API Token obtained in the Connections menu.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Authentication & Tokens",
      description:
        "Generating and managing secure Bearer authentication tokens per connection.",
      items: [
        {
          id: "bearer_token",
          title: "Bearer Token (Where to find it?)",
          definition:
            "Where to get the token? Go to Connections (/connections) in the sidebar, click the Edit button on the WhatsApp channel that will dispatch messages, switch to the Security tab, and click 'Copy Token' under the API Token card. Send it as an HTTP header: 'Authorization: Bearer <token>'.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "API de Mensagens",
    summary:
      "Integre sistemas externos (CRM, ERP, e-commerce ou gateways de pagamento) para enviar mensagens de texto e mídia via WhatsApp através de requisições HTTP REST autenticadas com token.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Endpoints de Envio",
      description:
        "URLs, cabeçalhos de autenticação e parâmetros JSON para disparos automáticos.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envio de Texto",
          definition:
            "Endpoint POST para disparar mensagens de texto. Requer o Token de API da conexão, obtido no menu Conexões > Editar canal do WhatsApp > seção Segurança > Copiar Token.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envio de Mídia e Arquivos",
          definition:
            "Permite anexar PDFs, imagens, vídeos ou áudios via URL pública ou multipart. Assim como nas mensagens de texto, requer o Token de API obtido no menu Conexões.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Segurança e Tokens",
      description:
        "Geração e controle de tokens Bearer de acesso por conexão.",
      items: [
        {
          id: "bearer_token",
          title: "Token de Autorização (Onde obter?)",
          definition:
            "Onde obter o token? Acesse o menu lateral Conexões (/connections), clique em Editar no canal do WhatsApp que enviará as mensagens, acesse a aba de Segurança e clique em 'Copiar Token'. Envie-o no cabeçalho HTTP 'Authorization: Bearer <token>'.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "API de Messages",
    summary:
      "Connectez des systèmes externes (CRM, ERP, e-commerce) pour envoyer des messages WhatsApp textuels et multimédias via des requêtes REST HTTP sécurisées par jeton Bearer.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Points de Terminaison (Endpoints)",
      description:
        "URLs, en-têtes d'autorisation et charges utiles JSON pour l'envoi automatisé.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envoi de Messages Texte",
          definition:
            "Endpoint POST pour envoyer des messages texte. Nécessite le Jeton d'API de la connexion, accessible dans le menu Connexions > Modifier le canal WhatsApp > section Sécurité > Copier le Jeton.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envoi de Médias et Fichiers",
          definition:
            "Permet d'envoyer des documents PDF, photos, vidéos ou vocaux via URL publique ou multipart. Authentifié obligatoirement par le Jeton d'API de la connexion obtenu dans le menu Connexions.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Jetons et Sécurité",
      description:
        "Génération et gestion des jetons d'autorisation Bearer.",
      items: [
        {
          id: "bearer_token",
          title: "Jeton d'Autorisation (Où l'obtenir ?)",
          definition:
            "Où obtenir le jeton ? Rendez-vous dans le menu latéral Connexions (/connections), cliquez sur Modifier du canal WhatsApp expéditeur, accédez à la section Sécurité et cliquez sur 'Copier le Jeton'. Envoyez-le dans l'en-tête HTTP 'Authorization : Bearer <jeton>'.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "واجهة برمجة الرسائل (Messages API)",
    summary:
      "اربط أنظمتك الخارجية (أنظمة إدارة العملاء، المتاجر الإلكترونية، بوابات الدفع) لإرسال رسائل واتساب نصية ووسائط عبر واجهة REST HTTP مؤمنة برمز توثيق.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. نقاط النهاية للإرسال (Endpoints)",
      description:
        "عناوين الروابط وترويسات التوثيق ومعاملات JSON للإرسال التلقائي.",
      items: [
        {
          id: "mensajes_texto",
          title: "إرسال الرسائل النصية",
          definition:
            "نقطة نهاية POST لإرسال الرسائل النصية الفردية. تتطلب رمز API الخاص بالاتصال، والذي يمكن الحصول عليه من قائمة الاتصالات > تعديل قناة واتساب > قسم الأمان > نسخ الرمز المميز.",
        },
        {
          id: "mensajes_multimedia",
          title: "إرسال الوسائط والملفات",
          definition:
            "إرسال ملفات PDF وصور ومقاطع فيديو وملاحظات صوتية عبر رابط عام أو ملف مرفق. تتطلب المصادقة باستخدام رمز API الخاص بالاتصال والمستخرج من قائمة الاتصالات.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. الأمان ورموز التوثيق",
      description:
        "توليد وإدارة رموز Bearer لتأمين وصول الأنظمة الخارجية.",
      items: [
        {
          id: "bearer_token",
          title: "رمز التفويض (من أين تحصل عليه؟)",
          definition:
            "من أين تحصل على الرمز المميز؟ انتقل إلى قائمة الاتصالات (/connections) في الشريط الجانبي، وانقر فوق زر التعديل (رمز القلم) لقناة واتساب المحددة، ثم توجه إلى قسم الأمان وانقر فوق 'نسخ الرمز'. استخدمه في ترويسة HTTP 'Authorization: Bearer <token>'.",
        },
      ],
    },
  ],
};

export const MESSAGES_API_HELP_DATA = { es, en, pt, fr, ar };
export default MESSAGES_API_HELP_DATA;
